import { createActionCreator } from '@pressreader/appstore';
import { IPublicationContentRestrictions, IssueContentRestrictions } from '@pressreader/content-types';

import { MODULE_NAME } from '../../../constants';

const pre = MODULE_NAME + '/issues/restrictions/';

interface LoadGlobalRestrictionsDonePayload {
    restrictions: { [cid: string]: IPublicationContentRestrictions };
}

interface LoadGlobalRestrictionsFailedPayload {
    error: unknown;
}

interface LoadIssueRestrictionsBeganPayload {
    cidDateKey: string;
}

interface LoadIssueRestrictionsDonePayload {
    cidDateKey: string;
    restrictions: IssueContentRestrictions;
}

interface LoadIssueRestrictionsFailedPayload {
    cidDateKey: string;

    error: unknown;
}

const loadGlobalRestrictionsBegan = createActionCreator(`${pre}load_global_restrictions_began`);
const loadGlobalRestrictionsCancelled = createActionCreator(`${pre}load_global_restrictions_cancelled`);
const loadGlobalRestrictionsDone = createActionCreator<LoadGlobalRestrictionsDonePayload>(`${pre}load_global_restrictions_done`);
const loadGlobalRestrictionsFailed = createActionCreator<LoadGlobalRestrictionsFailedPayload>(`${pre}load_global_restrictions_failed`);

const issueRestrictionsUpdated = createActionCreator<{
    cid: string;
    restrictions: IPublicationContentRestrictions;
}>(`${pre}issue_restrictions_updated`);

const loadIssueRestrictionsBegan = createActionCreator<LoadIssueRestrictionsBeganPayload>(`${pre}load_issue_restrictions_began`);
const loadIssueRestrictionsCancelled = createActionCreator<{ cidDateKey: string }>(`${pre}load_issue_restrictions_cancelled`);
const loadIssueRestrictionsDone = createActionCreator<LoadIssueRestrictionsDonePayload>(`${pre}load_issue_restrictions_done`);
const loadIssueRestrictionsFailed = createActionCreator<LoadIssueRestrictionsFailedPayload>(`${pre}load_issue_restrictions_failed`);

export {
    issueRestrictionsUpdated,
    loadGlobalRestrictionsBegan,
    loadGlobalRestrictionsCancelled,
    loadGlobalRestrictionsDone,
    loadGlobalRestrictionsFailed,
    loadIssueRestrictionsBegan,
    loadIssueRestrictionsCancelled,
    loadIssueRestrictionsDone,
    loadIssueRestrictionsFailed,
};
